import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSomethingWentWrong = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 153,
	height: 148,
	viewBox: "0 0 153 148",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			className: "bgCircle",
			cx: 76.5,
			cy: 64.7996,
			rx: 55.2,
			ry: 55.2,
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "dot",
			cx: 12.5,
			cy: 16.0004,
			r: 5.6,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "dot",
			cx: 8.89999,
			cy: 112.401,
			rx: 7.6,
			ry: 7.6,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "dot",
			cx: 144.9,
			cy: 33.1996,
			rx: 7.60001,
			ry: 7.6,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_dd_970_60787)",
			children: /* @__PURE__ */ _jsx("rect", {
				className: "bg",
				x: 28.5,
				y: 24.8008,
				width: 96,
				height: 79.2,
				rx: 6,
				fill: "#9FA8DF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "topBar",
			d: "M28.5 30.8008C28.5 27.4871 31.1863 24.8008 34.5 24.8008H118.5C121.814 24.8008 124.5 27.4871 124.5 30.8008V38.4008H28.5V30.8008Z",
			fill: "#7985D2"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "dot",
			cx: 132.9,
			cy: 4.4,
			rx: 4.39999,
			ry: 4.4,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "barDot",
			cx: 34.5,
			cy: 31.5996,
			rx: 2,
			ry: 2,
			fill: "#F3F3F7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "barDot",
			cx: 41.7,
			cy: 31.5996,
			r: 2,
			fill: "#F3F3F7"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "barDot",
			cx: 48.9,
			cy: 31.5996,
			rx: 2,
			ry: 2,
			fill: "#F3F3F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "questionMark",
			d: "M71.8516 62.0316C74.1211 57.9347 78.4832 55.5179 81.0179 51.8926C83.7 48.0905 82.1968 40.9874 74.5926 40.9874C71.6217 40.9874 69.5526 42.3294 68.1474 44.0755C66.684 45.8941 64.2932 47.1097 62.1417 46.2042L61.9147 46.1086C59.988 45.2978 58.9709 43.1074 60.0264 41.303C62.7887 36.5808 67.815 33 74.5632 33C81.4895 33 86.2347 36.1537 88.6516 40.1032C90.7147 43.4926 91.9232 49.8295 88.74 54.5453C85.2032 59.7621 81.8137 61.3537 79.9863 64.7137C79.5643 65.4902 79.2873 66.112 79.1277 67.321C78.8384 69.5111 77.1639 71.3158 74.9547 71.3158H74.3859C72.1967 71.3158 70.2958 69.5531 70.4343 67.3684C70.5436 65.6447 70.8895 63.7664 71.8516 62.0316ZM80.4874 83.1053C80.4874 86.3474 77.8347 89 74.5926 89C71.3505 89 68.6979 86.3474 68.6979 83.1053C68.6979 79.8632 71.3505 77.2105 74.5926 77.2105C77.8347 77.2105 80.4874 79.8632 80.4874 83.1053Z",
			fill: "#C6CBEC"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "questionMark",
			d: "M109.391 64.7271C112.258 63.0033 115.819 63.0662 118.682 61.7289C121.699 60.3348 123.306 55.4041 118.602 52.6883C116.801 51.6482 115.074 51.7153 113.601 52.2631C111.99 52.8619 110.018 52.7623 108.98 51.393C108.05 50.1669 108.208 48.3947 109.549 47.6414C112.935 45.741 117.291 45.3435 121.437 47.7368C125.721 50.2105 127.53 53.8561 127.615 57.1624C127.68 59.9959 126.165 64.3474 122.511 66.1277C118.46 68.0916 115.795 67.8656 113.465 69.2914C112.97 69.5943 112.598 69.8602 112.129 70.4374C111.063 71.7499 109.282 72.3216 107.817 71.4762C106.366 70.6384 105.773 68.7363 106.721 67.3549C107.388 66.3832 108.242 65.417 109.391 64.7271ZM107.206 80.8472C106.049 82.8528 103.46 83.5463 101.455 82.3884C99.4492 81.2305 98.7557 78.6422 99.9136 76.6367C101.071 74.6312 103.66 73.9376 105.665 75.0955C107.671 76.2534 108.364 78.8417 107.206 80.8472Z",
			fill: "#C6CBEC"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "questionMark",
			d: "M42.606 68.5535C42.333 66.734 43.1141 64.9373 43.0367 63.2012C42.9628 61.3747 40.7951 59.5209 38.4255 61.3401C37.518 62.0369 37.1891 62.9282 37.1575 63.7923C37.123 64.7368 36.6576 65.718 35.7433 65.9577C34.9246 66.1724 34.0572 65.7194 33.9566 64.879C33.703 62.7589 34.4172 60.4615 36.5055 58.8582C38.6638 57.2012 40.8969 57.0487 42.5949 57.7012C44.0487 58.2638 45.9413 59.9493 46.0776 62.1803C46.2235 64.6521 45.5481 65.959 45.7825 67.4432C45.8324 67.7583 45.8892 68.0034 46.0839 68.3631C46.5267 69.1809 46.4426 70.2063 45.7049 70.7727C44.9739 71.3339 43.8824 71.2355 43.3799 70.463C43.0264 69.9196 42.715 69.2825 42.606 68.5535ZM50.3386 73.0543C51.1143 74.0646 50.9223 75.5258 49.912 76.3014C48.9017 77.0771 47.4405 76.8851 46.6649 75.8748C45.8893 74.8645 46.0812 73.4033 47.0915 72.6277C48.1018 71.8521 49.563 72.044 50.3386 73.0543Z",
			fill: "#C6CBEC"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd_970_60787",
			x: 4.5,
			y: 20.8008,
			width: 144,
			height: 127.199,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 8 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_970_60787"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 20 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_970_60787",
					result: "effect2_dropShadow_970_60787"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_970_60787",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgSomethingWentWrong;
